import React from 'react';
import { NotificationBadge } from '../../UI/Badges';

export const InboxNotificationBadge = () => (
  <NotificationBadge showZero={false} isSidebar content={1} />
);
